<style lang="scss">
    .licensing-terms {
        .license-terms-table {
            .license-terms-line{
                font-family: Poppins;
                font-size: 13px;
                /*font-weight: 500;*/
                margin: 0 0 10px !important;
                text-align : center;
            }
        }
        .text-icons{
            font-size: 14px;
        }

        .green-text{
            color : #00D38A;
        }

        .white-text{
            color : #ffffff !important;
        }
        .loading-icon {
            text-align: center;
            font-size: 20px;
        }
        .contract-modal-link {
            text-align: center;
            padding: 10px 0;
            a {
                cursor: pointer;
            }
        }
        .contract {
            max-height: 300px;
            overflow-y: scroll;
            border: 1px solid #464147;
            padding: 10px;

        }
        ::-webkit-scrollbar {
            -webkit-appearance: none;
            width: 7px;
        }
        ::-webkit-scrollbar-thumb {
            border-radius: 4px;
            background-color: rgba(0,0,0,.5);
            -webkit-box-shadow: 0 0 1px rgba(255,255,255,.5);
        }

        @media (min-width: 769px) {
            .contract-modal-link:hover {
                text-decoration: underline;
            }
        }
    }

</style>

<template>
    <div class="licensing-terms">
        <div v-if="license.additionalTermsSet" class="license-terms-table">
            <p class="license-terms-line">MP3 File</p>
            <p class="license-terms-line" v-if="license.wav">WAV File</p>
            <p class="license-terms-line" v-if="license.trackout">Trackout File</p>
            <p class="license-terms-line" v-if="license.distribution !== 0">{{displayIntegerTerm(license.distribution)}} Distribution Copies</p>
            <p class="license-terms-line" v-if="license.distributionFree !== 0">{{displayIntegerTerm(license.distributionFree)}} Free Downloads</p>
            <p class="license-terms-line" v-if="license.performancesNonProfit !== 0">{{displayIntegerTerm(license.performancesNonProfit)}} Non Profit Performances</p>
            <p class="license-terms-line" v-if="license.performancesPaid !== 0">{{displayIntegerTerm(license.performancesPaid)}} Paid Performances</p>
            <p class="license-terms-line" v-if="license.musicVideos !== 0">{{displayIntegerTerm(license.musicVideos)}} Music Videos</p>
            <p class="license-terms-line" v-if="license.streamsAudio !== 0">{{displayIntegerTerm(license.streamsAudio)}} Audio Streams</p>
            <p class="license-terms-line" v-if="license.streamsVideo !== 0">{{displayIntegerTerm(license.streamsVideo)}} Video Streams</p>
            <p class="license-terms-line" v-if="license.broadcasting">{{displayIntegerTerm(license.radioStations)}} Radio Stations</p>
        </div>

        <div v-else>
            <div>
                <div class="license-terms-table">
                    <p class="license-terms-line">MP3 File</p>
                    <p class="license-terms-line" v-if="license.wav">WAV File</p>
                    <p class="license-terms-line" v-if="license.trackout">Trackout File</p>
                </div>

                <div v-if="contractModal" class="contract-modal-link"><a @click="setModalLicense(license)" data-toggle="modal" data-target="#license-terms">View License Agreement</a></div>
            </div>

        </div>

    </div>

</template>

<script>
    import Configure from './../mixins/configure'

    export default {
        props:  {
            license: {
                type: Object,
                required: true
            },
            user: {
                type: Object,
                required: true
            },
            contractModal: {
                type: Boolean,
                required: false,
                default: false
            },
            current: {
                type: Boolean,
                required: false,
                default: false
            }
        },
        data() {
            return {
                loading: {
                    contract: false
                },
                contract: null,
            }
        },
        mixins: [Configure],
        methods: {
            displayIntegerTerm(term) {
                switch (term) {
                    case -1 :
                        return "Unlimited"
                    case 0 :
                        return "None"
                    default :
                        return term
                }
            },
            setModalLicense(license) {
                this.$store.commit("modalLicense", {
                    modalLicense: license
                })
            }
        }
    }
</script>